import styled from "styled-components";

const CourseStyle = styled.div`
  // .main_container_box{
  //     height: 100vh;
  // }
  .user-title-container {
    display: flex;
    justify-content: space-between; 
    align-items: center;

  }
  .user-menu-title {
    font-size: 20px;
    font-weight: 500;
    color: #1f243b;
    margin-right: 0px;
    font-family: "DM Sans", sans-serif;
  }
  .users-menu-filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .create-course-button {
    width: 170px;
    height: 34px
    border-radius: 8px;
    border: 0.5px;
    background-color: #c2fae5;
    color: #1f243b;
    margin-left: 0px;
  }
  .total-course-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .total-course-left {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #1f243b;
    flex-shrink: 0;
  }

  .total-course-right {
    display: flex;
    gap: 20px;
  }

  .search-label,
  .date-label {
    width: 210px;
    height: 34px;
    border-radius: 24px;
    border: 1px solid #e2e2e8;
  }

  .search-input-field {
    margin-bottom: 0px !important;
    input {
      margin-bottom: 0px;
    }
  }

  .add_form_container_box {
    width: 50%;
  }
  .adduser-container {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 30px;
  }
  .upload-img-box {
    width: 200px;
  }
  .form_input_fields {
    .ant-row {
      display: flex;
      flex-direction: column;
    }
    .ant-form-item-label {
      text-align: left;
    }
  }

  .add-user-button {
    height: 2.5rem;
    min-width: 2.5rem;
    color: rgb(255, 255, 255);
    background-color: rgb(27, 104, 179);
    border: 1px solid rgb(27, 104, 179);

    &:hover {
      background-color: rgb(27, 104, 179) !important;
      border: 1px solid rgb(27, 104, 179) !important;
      color: rgb(255, 255, 255) !important;
    }
  }

  .course-enroll-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 34px;
    padding: 0 16px;
    border-radius: 8px;
    border: 0.5px solid transparent;
    background-color: #c2fae5;
    color: #1f243b;
    box-shadow: none;
    font-family: "DM Sans", sans-serif;
    font-size: 14px;

    &:hover {
      color: #1f243b !important;
      background-color: #c2fae5 !important;
      border: 0.5px solid transparent !important;
      box-shadow: none;
    }

    &:disabled,
    &.ant-btn-loading {
      color: #1f243b;
      background-color: #d9f7ea;
      opacity: 0.7;
    }
  }

  .course_filter_section_with_icon {
    display: flex;
    align-items: center;
    gap: 18px;
    flex: 1;
    width: 100%;
  }

  .single-action-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .download_csv_con {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 22px;
    width: 30px;
    height: 30px;
    background-color: rgb(245, 245, 246);
    cursor: pointer;
  }

  .yet-designed-pages {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .yet-designed-pages-image {
    width: 40%;
  }
  .developement-content {
    font-size: 1.266rem;
    line-height: 1;
    color: rgb(0, 0, 0);
    margin-bottom: 1rem;
  }
  .developement-span-content {
    font-size: 1.125rem;
    font-weight: 400;
    color: rgb(158, 165, 169);
    margin-bottom: 1rem;
  }
  .developement-add-button {
    font-size: 0.889rem;
    height: 2.5rem;
    min-width: 2.5rem;
    color: rgb(255, 255, 255);
    background-color: rgb(27, 104, 179);
    border: 1px solid rgb(27, 104, 179);
  }

  .course-breadcrumb {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-family: "DM Sans", sans-serif;
    color: #636980;

    a {
      color: #636980;
      text-decoration: none;
    }

    .breadcrumb-current {
      color: #1f243b;
      font-weight: 500;
    }
  }

  .header-action-buttons {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .edit-course-outline-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 16px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #1f243b;
    cursor: pointer;
    font-family: "DM Sans", sans-serif;
    font-size: 14px;

    &:hover,
    &:focus {
      background: #c2fae5 !important;
      border: 0.5px solid transparent !important;
      color: #1f243b !important;
    }
  }

  .row-action-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #c2fae5;
    color: #1f243b;
    cursor: pointer;
    font-size: 13px;
  }

  .row-action-icon-danger {
    background: #f0f0f0;
    color: #e74c3c;
  }

  .row-remove-link {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #e74c3c;
    cursor: pointer;
    font-size: 13px;
    justify-content: flex-end;
    width: fit-content;
    margin-left: auto;
  }

  .upload-dropzone {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 32px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
    text-align: center;
    cursor: pointer;
  }

  .upload-dropzone .browse-link {
    color: #2d53da;
    cursor: pointer;
  }

  .staged-file-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 4px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
    color: #1f243b;

    svg {
      cursor: pointer;
      color: #636980;
    }
  }
`;

export default CourseStyle;
